import { useContext, useEffect, useState } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import { motion } from "framer-motion"

import TopoMenu from "../../../componentes/gerais/TopoMenu"
import MenuLateral from "../../../componentes/gerais/Menu"

import { configAnim } from "../../../servicos/config/configAnim"
import { Avatar, Chip, CircularProgress, Divider, Select } from "@mui/material"
import { ContextoGeral } from "../../../contextos/ContextoGeral"
import { MdEdit, MdLogout, MdStar, MdPrivacyTip, MdTwoWheeler, MdSave } from "react-icons/md"
import { LogoBottom } from "./styles"
import ProfissionalAPI from "../../../servicos/ProfissionalAPI"

export default function TrocarCategoria() {

    const { dados, setDados, deslogar } = useContext(ContextoGeral);

    const [categorias, setCategorias] = useState([]);
    const [msg, setMsg] = useState({
        status: false,
        msg: ''
    });
    const [msgTrocar, setMsgTrocar] = useState({
        status: false,
        msg: ''
    });

    const [carregandoCategorias, setCarregandoCategorias] = useState(true);
    const [salvando, setSalvando] = useState(false);

    const [menu, setMenu] = useState(false);
    const [categoriaSelecionada, setCategoriaSelecionada] = useState(dados.siglaTipoVeiculo || '');
    const [descricaoCategoriaSelecionada, setDescricaoCategoriaSelecionada] = useState(dados.tipoVeiculo || '');

    useEffect(() => {
        setCarregandoCategorias(true);
        ProfissionalAPI.buscarCategorias(dados).then(res => {
            if (res?.codigo == 200) {
                setCategorias(res?.dados);
            } else {
                setMsg({
                    status: false,
                    msg: 'Erro ao buscar categorias. Por favor tente novamente.'
                });
            }
        }).catch(err => {
            setMsg({
                status: false,
                msg: 'Houve um problema ao buscar os tipos de veículos.'
            });
        }).finally(() => {
            setCarregandoCategorias(false);
        });
    }, []);

    function handleTrocarCategoria() {
        if (!categoriaSelecionada) {
            setMsgTrocar({
                status: false,
                msg: 'Selecione uma categoria válida.'
            });
            return;
        }

        setSalvando(true);
        const dadosSelecionados = {
            idProf: dados.idProf,
            categoria: categoriaSelecionada
        };

        ProfissionalAPI.trocarCategoria(dados, dadosSelecionados).then(res => {
            console.log('Resposta da API trocarCategoria:', {
                codigo: res?.codigo,
                mensagem: res?.mensagem,
                dados: res?.dados,
                respostaCompleta: res
            });

            if (res?.codigo == 200) {
                setMsgTrocar({
                    status: true,
                    msg: 'Categoria alterada com sucesso!'
                });
                
                novoTipoVeiculo()
            } else {
                console.error('Erro ao trocar categoria - resposta da API:', res);
                setMsgTrocar({
                    status: false,
                    msg: 'Erro ao trocar categoria. Por favor tente novamente.'
                });
            }
        }).catch(err => {
            console.error('Erro ao trocar categoria - exceção:', err);
            setMsgTrocar({
                status: false,
                msg: 'Houve um problema ao trocar a categoria.'
            });
        }).finally(() => {
            setSalvando(false);
        });
    }

    function novoTipoVeiculo() {
        // Criar um novo objeto em vez de mutar o existente para garantir que o React detecte a mudança
        const novosDados = {
            ...dados,
            tipoVeiculo: descricaoCategoriaSelecionada,
            siglaTipoVeiculo: categoriaSelecionada
        };
        console.log('trocar categoria - dados atualizados:', novosDados);

        setDados(novosDados)
    }

    return (
        <motion.div
            initial={configAnim.initial}
            animate={configAnim.animate}
            exit={configAnim.exit}
            transition={configAnim.transition}
            className="flex flex-col justify-between"
        >
            <TopoMenu voltar="/app/perfil" state={{ 'tipoVeiculo': descricaoCategoriaSelecionada }} titulo="Alterar categoria" setShow={setMenu} />

            <div className="flex flex-col items-center">
                {carregandoCategorias ? (
                    <CircularProgress size={22} />
                ) : (
                    <>
                        <h5 className="mt-4">Selecione a nova categoria</h5>
                        <select
                            id="NovaCategoria"
                            className="w-11/12 p-2 mt-2 border rounded appearance-none"
                            onChange={(e) => {
                                setCategoriaSelecionada(e.target.value);
                                setDescricaoCategoriaSelecionada(e.target.options[e.target.selectedIndex].text)
                            }}
                            value={categoriaSelecionada}
                        >
                            <option value="">Selecione a categoria</option>
                            {categorias.map((c) => (
                                <option key={c.tipo} value={c.tipo}>{c.descricao}</option>
                            ))}
                        </select>

                        <button
                            onClick={handleTrocarCategoria}
                            className="flex items-center justify-center gap-2 px-4 py-2 mt-4 font-normal text-white bg-blue-600 rounded hover:bg-blue-700 transition-all disabled:opacity-50"
                        >
                            <MdSave className="w-5 h-5" /> Salvar
                        </button>
                    </>
                )}

                {msg.msg && categorias.length === 0 && (
                    <p className="mt-2 bg-red-600 text-white text-sm w-11/12 text-center py-2">
                        {msg.msg}
                    </p>
                )}

                {salvando ? (
                    <CircularProgress size={22} />
                ) : msgTrocar.msg && (
                    <div
                        className={`mt-4 px-4 py-2 rounded text-white text-sm w-11/12 text-center 
                        ${msgTrocar.status ? "bg-green-600" : "bg-red-600"}`}
                    >
                        {msgTrocar.msg}
                    </div>
                )}
            </div>


            <MenuLateral show={menu} setShow={setMenu} />
        </motion.div>

    )
}